<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>

          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <h1 class="h3 mb-2 mt-2 text-gray-800">資料庫處理</h1>

            <!-- DataTales Example -->
            <div class="card shadow mb-4">
              <div class="card-header py-3">
              </div>
              <div class="card-body">

                <div class="form-group row">
                  <div class="col-sm-2">
                      <label class="form-check-label" >Banner</label>
                  </div>
                  <div class="col-sm-2">
                    <i class="fas fa-check-circle text-success" v-if="banner.check"></i>
                    <i class="fas fa-times-circle text-danger" v-if="!banner.check"></i>
                  </div>
                  <div class="col-sm-4">
                    <p>{{banner.msg}}</p>
                  </div>
                  <div class="col-sm-4">
                    <button type="button" class="btn btn-primary" v-on:click="ResetBanner()" >Reset</button>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-sm-2">
                      <label class="form-check-label" >Banner 英文版</label>
                  </div>
                  <div class="col-sm-2">
                    <i class="fas fa-check-circle text-success" v-if="banner_en.check"></i>
                    <i class="fas fa-times-circle text-danger" v-if="!banner_en.check"></i>
                  </div>
                  <div class="col-sm-4">
                    <p>{{banner_en.msg}}</p>
                  </div>
                  <div class="col-sm-4">
                    <button type="button" class="btn btn-primary" v-on:click="ResetBannerEN()" >Reset</button>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-sm-2">
                      <label class="form-check-label" >Category 英文版</label>
                  </div>
                  <div class="col-sm-2">
                    <i class="fas fa-check-circle text-success" v-if="category_en.check"></i>
                    <i class="fas fa-times-circle text-danger" v-if="!category_en.check"></i>
                  </div>
                  <div class="col-sm-4">
                    <p>{{category_en.msg}}</p>
                  </div>
                  <div class="col-sm-4">
                    <button type="button" class="btn btn-primary" v-on:click="CategoryImport()" >Reset</button>
                  </div>
                </div>

              </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

       <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
export default {
  name: 'ImportDB',
  data () {
    return {
      banner:{
        check:false,
        msg:''
      },
      banner_en:{
        check:false,
        msg:''
      },
      category_en:{
        check:false,
        msg:''
      },
      bannerDefaultData:
      [{id:'1',link:'',pc:{src:'',width:'',height:'',name:''},mobile:{src:'',width:'',height:'',name:''}},
      {id:'2',link:'',pc:{src:'',width:'',height:'',name:''},mobile:{src:'',width:'',height:'',name:''}},
      {id:'3',link:'',pc:{src:'',width:'',height:'',name:''},mobile:{src:'',width:'',height:'',name:''}},
      {id:'4',link:'',pc:{src:'',width:'',height:'',name:''},mobile:{src:'',width:'',height:'',name:''}},
      {id:'5',link:'',pc:{src:'',width:'',height:'',name:''},mobile:{src:'',width:'',height:'',name:''}}]
      ,catrgoryDefaultData:
      [
        {id:'news',name:'最新消息',order:0,list:[]},
        {id:'media',name:'媒體報導',order:1,list:[]},
        {id:'view',name:'社會觀點',order:2,list:[]},
        {id:'world',name:'全球新訊',order:3,list:[]},
        {id:'cooperate',name:'產學合作',order:4,list:[]},
        {id:'research',name:'學術研究',order:5,list:[]}
      ],catrgoryENDefaultData:
      [
        {id:'news',name:'NEWS',order:0,list:[]},
        {id:'media',name:'MEDIA',order:1,list:[]},
        {id:'view',name:'VIEW',order:2,list:[]},
        {id:'world',name:'WORLD VIEWS',order:3,list:[]},
        {id:'cooperate',name:'COOPERATE',order:4,list:[]},
        {id:'research',name:'RESEARCH',order:5,list:[]}
      ]
      
    }
  },
  mounted () {
    this.BannerCheck();
    this.BannerENCheck();
    //this.CategoryImport();
  },
  methods: {
    async BannerCheck() {
      //  檢查資料存在
      const commentRef = await db.collection('banner').get();
      if ( !commentRef.empty ) this.banner.check = true; 

      //  檢查是否有五筆
      db.collection('banner').get().then((querySnapshot) => {
        if ( querySnapshot.size != 5 ) {
          this.banner.check = false;
          this.banner.msg = 'Banner未滿五張' 
        }
      })
    },
    ResetBanner() {
      this.banner.check = false;
      this.banner.msg = '處理中..';
      var batch = db.batch();
      this.bannerDefaultData.forEach(function(value, index, array){
          var sfRef = db.collection("banner").doc(value.id);
          batch.set(sfRef, value);
      });

      batch.commit()
      .then(() => {
          this.banner.check = true;
          this.banner.msg = '完成';
      }).catch(()=>{
          this.banner.check = false;
          this.banner.msg = '失敗';
      });
    },
    async BannerENCheck() {
      //  檢查資料存在
      const commentRef = await db.collection('banner_en').get();
      if ( !commentRef.empty ) this.banner_en.check = true; 

      //  檢查是否有五筆
      db.collection('banner_en').get().then((querySnapshot) => {
        if ( querySnapshot.size != 5 ) {
          this.banner_en.check = false;
          this.banner_en.msg = 'Banner未滿五張' 
        }
      })
    },
    ResetBannerEN() {
      this.banner_en.check = false;
      this.banner_en.msg = '處理中..';
      var batch = db.batch();
      this.bannerDefaultData.forEach(function(value, index, array){
          var sfRef = db.collection("banner_en").doc(value.id);
          batch.set(sfRef, value);
      });

      batch.commit()
      .then(() => {
          this.banner_en.check = true;
          this.banner_en.msg = '完成';
      }).catch(()=>{
          this.banner_en.check = false;
          this.banner_en.msg = '失敗';
      });
    },
    CategoryImport() {
     
      this.category_en.check = false;
      var batch = db.batch();
      this.catrgoryENDefaultData.forEach(function(value, index, array){
          var sfRef = db.collection("category_en").doc(value.id);
          batch.set(sfRef, value);
      });
      batch.commit()
      .then(() => {
          this.category_en.check = true
          this.category_en.msg = '完成';
      }).catch(()=>{
          this.category_en.check = false
          this.category_en.msg = '失敗';
      });
    },
    async Check() {

      for( var i = 0 ; i < this.collection.length ; i++) {
        const commentRef = await db.collection(this.collection[i].name).get();
        if ( !commentRef.empty ) this.collection[i].check = true;
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Import.vue